import { useCallback, useMemo, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { Formik } from "formik";
import LoadingButton from "components/shared/LoadingButton";
import { errorMessageToast } from "helpers/common";
import close from "../../../Assets/images/cross_icon.png"
// css
import styles from "./index.module.scss";
import { CstmPagination } from "components/Common/Common";
import { useGetStartegyTemplatesQuery } from "store/services/clients/reports-v2/recommendationTemplates";
import { useGetDisciplineTagsQuery } from "store/services/utility";
import { useSelector } from "react-redux";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import moment from "moment";
import { debounce } from "lodash";
import searchIcon from "../../../Assets/icons/searchIcon.png"
import { useNavigate } from "react-router-dom";

const TaskPlanStrategyModal = ({
    showPopup,
    closePopup,
    data,
    clientType,
    assessmentId,
    outerFieldName,
    currentStrategyFieldName = 'strategy',
    strategyIndex,
    index,
    mainSetFieldValue,
    setSelectedTemplate
}) => {

    const [currentPage, setCurrentPage] = useState(1)
    const [templateId, setTemplateId] = useState(null)
    const pageSize = 5;

    const [filter, setFilter] = useState({ tags: [], search: "" })

    const disciplineId = useSelector((state) => state?.auth?.user?.therapist_discipline?.id)
    const { data: disciplineTags } = useGetDisciplineTagsQuery(disciplineId, { skip: !disciplineId });
    const disciplineTagOptions = disciplineTags?.length > 0 ? disciplineTags?.map(area => ({ value: area.id, label: area.name })) : [];

    const { data: strategyTemplates, isError, isFetching } = useGetStartegyTemplatesQuery({
        page: currentPage,
        limit: pageSize,
        ...filter
    });

    const totalRecords = strategyTemplates?.totalRecords || 0;
    const totalPages = Math.ceil(totalRecords / pageSize);

    const initialValues = useMemo(() => {
        return {
            title: data?.title || "",
            answers: data?.answers || "",
        }
    }, [data]);

    // FIXED: Updated to use the correct path structure for task plan templates
   const addToReport = (values) => {

    const strategyPath = `tasks.${index}.strategy.${strategyIndex}`;

    mainSetFieldValue(`${strategyPath}.text`, values?.answers || "");
    mainSetFieldValue(`${strategyPath}.title`, values?.title);
    mainSetFieldValue(`${strategyPath}.template_id`, values?.id);
    mainSetFieldValue(`${strategyPath}.strategyRadio`, "oldStrategy");
    mainSetFieldValue(`${strategyPath}.attachments`, values?.attachments || []);

    if (values?.id) {
        const templateOption = {
            label: values?.title,
            value: {
                id: values?.id,
                text: values?.answers || "",
                attachments: values?.attachments || []
            }
        };
        setSelectedTemplate(templateOption);
    }
};

    const column = [
        {
            head: "Name",
            accessor: "name",
            isComponent: true,
            component: (item) => (
                <div className="d-flex align-items-center gap-2">
                    <div className="session-input-radio text-area-report">
                        <div className="radio-inputs">
                            <div className="d-flex align-items-center py-1">
                                <input
                                    type="radio"
                                    id={`table-radio-${item?.id}`}
                                    value={item?.id}
                                    onChange={(e) => {
                                        setTemplateId(e.target.value)
                                    }}
                                    checked={item?.id == templateId}
                                />
                            </div>
                        </div>
                    </div>
                    <h6 className="m-0" style={{ color: "#315D99", fontSize: 14 }}>{item?.title}</h6>
                </div>
            ),
        },
        {
            head: "Date Used",
            accessor: "lastUsed",
            isComponent: true,
            component: (item) => (
                <div>{item?.lastUsed ? moment(item.lastUsed).format("DD/MM/YYYY") : "--"}</div>
            ),
        },
        {
            head: "Tags",
            accessor: "tags",
            isComponent: true,
            component: (item) => (
                <div className="d-flex area-pills flex-wrap gap-2 mt-2">
                    {item?.StrategyTemplateTagsMapping?.map((tag, idx) => (
                        <button
                            style={{ border: "0px" }}
                            key={idx}
                            type="button"
                            className="select-liberary-btn border-0"
                        >
                            {tag?.strategyTemplateTags?.name}
                        </button>
                    ))}
                </div>
            ),
        },
    ];

    const handlePageChange = (page) => {
        window.scrollTo(0, 0);
        setCurrentPage(page);
    };

    const handleSubmit = async () => {
        if (!templateId) {
            errorMessageToast("Please select the template");
            return;
        }

        const template = strategyTemplates?.records?.find((item) => item?.id == templateId);
        if (template) {
            addToReport(template);
            closePopup();
            // Reset templateId for next time
            setTemplateId(null);
        } else {
            errorMessageToast("Template not found");
        }
    }

    const handleSearch = useCallback(debounce((e) => {
        if (e.target.value) {
            setFilter((prev) => ({ ...prev, search: e.target.value }))
        } else {
            setFilter((prev) => ({ ...prev, search: "" }))
        }
    }, 500), [clientType]);

    const handleTagClick = (tag) => {
        if (filter?.tags?.includes(tag?.value)) {
            const list = filter?.tags?.filter((t) => t !== tag?.value);
            setFilter((prev) => ({ ...prev, tags: list }));
        } else {
            setFilter((prev) => ({ ...prev, tags: [...prev.tags, tag?.value] }));
        }
    };

    return (
        <Modal
            show={showPopup}
            className={`${styles.AddNewGoalPop} modal-v2 AddNewGoalPop`}
            onHide={closePopup}
            backdrop="static"
            keyboard={false}
            centered
            size="lg"
        >
            <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {({
                        handleSubmit,
                        isSubmitting,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <div className="reports-v2">
                                <div className="section-title d-flex align-items-center justify-content-between" style={{ borderColor: "#315D99" }}>
                                    <h6 className="mb-0 section-title border-bottom-0" style={{ color: "#315D99" }}>{"CHOOSE FROM MY LIBRARY"}</h6>
                                    <img onClick={closePopup} width={16} height={16} src={close} alt="close" style={{ cursor: "pointer" }} />
                                </div>
                                <Row>
                                    <Col md="12" className="my-2 name-input-v2">
                                        <label
                                            htmlFor=""
                                            className="discharge-screen-label mt-0"
                                        >
                                            Search
                                        </label>
                                        <div className={`${styles.formControl} readonly-box h-auto d-flex justify-content-center`}>
                                            <input
                                                name="title"
                                                style={{ border: 0, width: "100%", outline: "none" }}
                                                placeholder="Type to search for a strategy"
                                                onChange={handleSearch}
                                            />
                                            <img width={21} height={21} src={searchIcon} alt="searchIcon" />
                                        </div>
                                    </Col>
                                    <div className="btnWrpper mt-2 text-end gap-2 d-flex justify-content-end">
                                        <LoadingButton
                                            style={{ background: "#fff", border: "1px solid #315D99", color: "#315D99", padding: "11px 30px" }}
                                            onClick={closePopup}
                                            type="button"
                                            className="blue-discharge-screen-btn"
                                            isLoading={isSubmitting}
                                        >
                                            Cancel
                                        </LoadingButton>

                                        <LoadingButton
                                            type="submit"
                                            className="blue-discharge-screen-btn"
                                            isLoading={isSubmitting}
                                        >
                                            Use Selected Template
                                        </LoadingButton>
                                    </div>

                                    <Col md="12" className="my-2">
                                        <label className="discharge-screen-label mt-0 mb-0">
                                            Choose Tags
                                        </label>
                                        <div className="d-flex area-pills flex-wrap gap-2 mt-2">
                                            {disciplineTagOptions.map((tag) => (
                                                <button
                                                    key={tag.value}
                                                    type="button"
                                                    className={filter?.tags?.includes(tag?.value) ? "select-liberary-btn proxima-regular" : "non-select-liberary-btn proxima-regular"}
                                                    onClick={() => handleTagClick(tag)}
                                                >
                                                    {tag?.label}
                                                </button>
                                            ))}
                                        </div>
                                    </Col>

                                    <hr className="mt-3" style={{ color: "#000" }} />

                                    <Col lg="12" className="mb-3">
                                        <label className="discharge-screen-label mt-0 mb-0">
                                            Select a Strategy
                                        </label>
                                        <div className="table-outer">
                                            {isError ? (
                                                <ErrorComponent />
                                            ) : (
                                                <>
                                                    {isFetching && <LoadingOverlay />}
                                                    <TableLayout
                                                        data={strategyTemplates?.records}
                                                        column={column}
                                                        height={"275px"}
                                                    />
                                                </>
                                            )}
                                            <CstmPagination
                                                totalPages={totalPages}
                                                activePage={currentPage}
                                                handlePageChange={handlePageChange}
                                            />
                                        </div>
                                    </Col>
                                </Row>

                            </div>
                        </form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
};

export default TaskPlanStrategyModal;

const TableLayout = ({ column, data, url, showHeader = true, noDataMsg = "Data not found", state, handleRowClick, height }) => {
    const navigate = useNavigate();
    return (
        <div className="favorite-goal-wrapper table_height" style={{ height: height || "calc(100vh - 220px)" }}>
            <div className={`${styles.tableResponsive} table-responsive mb-3 h-100`}>
                <table className={`${styles.table} table`}>
                    {showHeader && (
                        <thead>
                            <tr>
                                {column.map((item, key) => (
                                    <th key={key} className="proxima" style={{ borderBottom: "2px solid #315D99", fontWeight: "100" }}>
                                        {item.head}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                    )}
                    <tbody>
                        {data && data?.length > 0 ? (
                            data.map((dataItem, rowIndex) => {
                                return (
                                    <tr
                                        key={dataItem?.id || rowIndex}
                                        className={`${url && "cursor-pointer"}`}
                                        onClick={(e) => {
                                            if (url) {
                                                navigate(`${url}/${dataItem.id}`, { state });
                                            }
                                            if (handleRowClick && typeof handleRowClick === "function") {
                                                handleRowClick(dataItem);
                                            }
                                        }}
                                    >
                                        {column.map((item, colIndex) => {
                                            if (item.isComponent) {
                                                return (
                                                    <td key={colIndex} className="proxima" style={{ fontWeight: "100" }}>
                                                        {item.component(dataItem, rowIndex, dataItem)}
                                                    </td>
                                                );
                                            }
                                            return (
                                                <td key={colIndex} className="proxima-regular">
                                                    {dataItem[item?.accessor] || "--"}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={column?.length || 1} className="text-center">
                                    {noDataMsg}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};